import { Table, TableWrapper, Tbody, Td, Th, Thead, Tr } from '@components/core-ui/Table';
import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { Radio } from '@components/core-ui/form-elements/Radio';
import { ModalTitle } from '@modals/core-ui/ModalTitle';
import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { AbsoluteSpinner } from '@components/core-ui/spinners/Spinner';
import { Tooltip } from '@components/core-ui/Tooltip';
import { useAuthContext } from '@providers/AuthProvider';
import { JobsService } from 'app/API';
import { useState } from 'react';

import { Content } from './styles/Content';

type TProps = {
  jobIds: string[];
  onCancel: () => void;
  onSuccess: () => void;
};

export const MoveJobsToWSModal = ({ jobIds, onCancel, onSuccess }: TProps) => {
  const { workspace, organization } = useAuthContext();
  const [selectedWorkspaceId, setSelectedWorkspaceId] = useState(workspace?.id ?? '');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    setIsSubmitting(true);
    await JobsService.moveJobsToWs({
      wsid: workspace?.id ?? '',
      requestBody: { jobIds, workspaceId: selectedWorkspaceId },
    });
    setIsSubmitting(false);
    onSuccess();
    onCancel();
  };

  return (
    <ModalWrapper width="487px">
      {isSubmitting ? <AbsoluteSpinner overlay={true} /> : null}
      <ModalTitle>Move Jobs to another workspace</ModalTitle>
      <Content>
        <TableWrapper className="customTable">
          <Table>
            <Thead $white>
              <Tr>
                <Th>Workspace Name</Th>
              </Tr>
            </Thead>
            <Tbody>
              {organization?.workspaces?.map((data) => {
                const disabled = workspace?.id === data.id || !organization?.permissions?.submitJobs;
                const disabledInfo =
                  selectedWorkspaceId === data.id
                    ? 'Cannot move jobs to the same Workspace'
                    : `You don't have "Submit Jobs" permission on this Workspace`;
                return (
                  <Tr key={data.id}>
                    <Td>
                      {disabled ? (
                        <Tooltip content={disabledInfo} placement="bottom">
                          <div className="radioWrapper disabled">
                            <Radio onChange={() => {}} checked={selectedWorkspaceId === data.id} disabled={true}>
                              {data?.name}
                            </Radio>
                          </div>
                        </Tooltip>
                      ) : (
                        <div className="radioWrapper">
                          <Radio
                            onChange={() => setSelectedWorkspaceId(data.id)}
                            checked={selectedWorkspaceId === data.id}
                          >
                            {data?.name}
                          </Radio>
                        </div>
                      )}
                    </Td>
                  </Tr>
                );
              })}
            </Tbody>
          </Table>
        </TableWrapper>

        <div className="buttonGroup">
          <OutlinedButton onClick={onCancel}>Cancel</OutlinedButton>
          <Button disabled={selectedWorkspaceId === workspace?.id} onClick={handleSubmit}>
            Move
          </Button>
        </div>
      </Content>
    </ModalWrapper>
  );
};
